import React from "react";
import logo from "../assets/logo.png";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
  FaStar,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-pink-50 text-gray-700 text-sm pt-12 sm:pt-16 pb-8 px-4 sm:px-6 mt-14 sm:mt-20">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8 sm:gap-10 items-start text-center md:text-left">
        <div className="space-y-3">
          <div className="flex items-center justify-center md:justify-start gap-3">
            <img src={logo} alt="Fiesta Logo" className="h-10 w-auto" />
            <h4 className="font-semibold elegant-font text-lg mb-2 text-center">Fiesta Event Decor</h4>
          </div>
          <p className="text-gray-600 leading-relaxed">
            Fiesta Event Decor is based in Cohoes, New York. Work directly with the owner to plan décor for your wedding, birthday, or family celebration.
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-4">
            <a
              href="https://www.facebook.com/sarithaGajjala03/reviews"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-green-700 text-sm hover:underline font-medium py-2"
            >
              <FaStar className="text-yellow-400" />
              Read our Facebook Reviews &rarr;
            </a>

            <div className="flex gap-4 text-lg justify-center">
              <a
                href="https://www.facebook.com/sarithaGajjala03"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-green-700 p-2"
                aria-label="Fiesta Event Decor Facebook"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com/fiesta_event_decor"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-500 p-2"
                aria-label="Fiesta Event Decor Instagram"
              >
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>

        <div className="text-sm text-gray-600">
          <h4 className="font-semibold elegant-font text-lg mb-2 text-center">Events We Decorate</h4>
          <div className="grid grid-cols-1 min-[420px]:grid-cols-2 gap-x-4 gap-y-2">
            <span>Weddings</span>
            <span>Engagements & Showers</span>
            <span>Baby Showers</span>
            <span>Gender Reveals</span>
            <span>Birthdays</span>
            <span>Graduations</span>
            <span>Anniversaries</span>
            <span>Housewarmings</span>
            <span>Poojas</span>
            <span>Womensday Events</span>
          </div>
        </div>

        <div>
          <h3 className="font-semibold elegant-font text-lg mb-2">Contact Information</h3>
          <p className="mb-1">20 Sutton Dr<br />Cohoes, NY 12047</p>
          <p className="flex items-center justify-center md:justify-start gap-2">
            <FaEnvelope className="text-rose-400" /> fiestaevent9@gmail.com
          </p>
          <p className="flex items-center justify-center md:justify-start gap-2">
            <FaPhone className="text-rose-400" /> 412-228-9722
          </p>
          <p className="flex items-center justify-center md:justify-start gap-2">
            <FaMapMarkerAlt className="text-rose-400" /> Cohoes, NY
          </p>
        </div>
      </div>

      <div className="border-t border-gray-200 mt-10 sm:mt-12 pt-6 text-center text-sm text-gray-500">
        <div className="flex justify-center gap-4 mb-4">
          <a href="https://www.facebook.com/sarithaGajjala03/" target="_blank" rel="noopener noreferrer" aria-label="Fiesta Event Decor Facebook" className="p-2">
            <FaFacebookF className="text-blue-600 hover:text-blue-800" />
          </a>
          <a href="https://instagram.com/fiesta_event_decor" target="_blank" rel="noopener noreferrer" aria-label="Fiesta Event Decor Instagram" className="p-2">
            <FaInstagram className="text-pink-500 hover:text-pink-700" />
          </a>
        </div>
        <p className="text-sm text-gray-500">&copy; 2025 Fiesta Event Decor</p>
        <p className="text-sm text-gray-500">
          <strong>Developed by</strong>{" "}
          <a
            href="https://dhriti.solutions"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline text-gray-600"
          >
            Dhriti.Solutions - Service-Focused, Budget-Conscious Web Development
          </a>
        </p>
      </div>
    </footer>
  );
}
